// import React from "react";
// import GitHubCalendar from "react-github-calendar";
// import { Row } from "react-bootstrap";

// function Github() {
//   return (
//     <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
//       <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
//         <strong className="purple">Experience</strong>
//       </h1>
//       {/* <GitHubCalendar
//         username="Mridul07Sharma"
//         blockSize={15}
//         blockMargin={5}
//         color="#c084f5"
//         fontSize={16}
//       /> */}
//     </Row>
//   );
// }

// export default Github;



import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./Cards";
import Particle from "../Particle";
import chatify from "../../Assets/Projects/chatify.jpg";
import bitsOfCode from "../../Assets/Projects/blog.jpg";

function Github() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          <strong className="purple">Experience </strong>
        </h1>
        <p style={{ color: "white" }}>
          Position of Responsibility and Interns
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Coordinator"
              description="Robotics Society NIT Hamirpur provide students a place to pursue their interest in robotics by working on large and small scale robotics projects."
              ghLink="https://robosocnith.com/"
              // demoLink="https://www.linkedin.com/in/mridul-sharma-5a8520221/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Web Developer Intern"
              description="Joined Let's Grow More Virtual Internship Program in July 2022 and worked on many projects like making registration form whose data displays on the same project."
              ghLink="https://drive.google.com/file/d/1F7tQTiEWJUKb4M1Iui-chx7vrTTzKPLG/view"
              demoLink="https://drive.google.com/file/d/1l9z81IJtD1C9or3AzbrsDELbGUA0epYS/view"
            />
          </Col>

          
        </Row>
      </Container>
    </Container>
  );
}

export default Github;